import { appWerklijstG4Tr } from './golf4App.tr.js';
// Turks (tr-TR), werklijstApp: zelfde vorm als werklijstApp.nl.ts (golf 3-integratie). Alleen de
// schermteksten; de punten zelf blijven Nederlands (docs/werklijst.json).
export const appWerklijstTr = {
    ...appWerklijstG4Tr,
    title: 'İş listesi',
    subtitle: 'Yalnızca yönetici olarak senin için · güncellendi {when}',
    progress: '{total} işten {done} tanesi hazır',
    progressLabel: 'İlerleme: {total} maddeden {done} tanesi hazır',
    progressRegion: 'İlerleme',
    status: {
        waiting_on_you: 'Seni bekliyor',
        in_progress: 'Devam ediyor',
        planned: 'Planlandı',
        later: 'Sonra',
        done: 'Hazır',
    },
    filterAll: 'Hepsi',
    filterLabel: 'Göster',
    filterActive: 'Şu an yalnızca şunu görüyorsun: {status}',
    showAll: 'Hepsini göster',
    needsYou: 'Senden ihtiyacım olanlar',
    needsYouCount: {
        one: 'Seni bekleyen bir madde var.',
        other: 'Seni bekleyen {count} madde var.',
    },
    show: 'Göster',
    doneAt: 'Hazır: {when}',
    whatIsIt: 'Bu nedir?',
    yourAction: 'Senin ne yapman gerekiyor?',
    numberLabel: 'geri bildiriminden {n}. madde',
    groupCount: '{total} işten {done} tanesi hazır',
    emptyTitle: 'Bu durumda bir şey yok',
    emptyBody: 'Yukarıda başka bir durum seç veya Hepsi’ni seç.',
    unavailable: 'İş listesi şu an okunamıyor. Birazdan tekrar dene.',
};
//# sourceMappingURL=werklijstApp.tr.js.map